import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest
       } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

/**
 * Required to make userinfo useable in all modern browsers.
 * More information: https://tools.ietf.org/html/rfc3986#section-3.2.1
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor
{
  public intercept(
      req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
  {
    const match = req.url.match(/\/\/([^\/]*)@.+\./);
    if (match) {
      const userinfo = match[1];
      const splitted = userinfo.split(':');
      const user = decodeURIComponent(splitted[0]);
      const pass = decodeURIComponent(splitted[1]);
      const credentials = btoa(`${user}:${pass}`);
      req = req.clone({
        url: req.url.replace(userinfo + '@', ''),
        headers: req.headers.set('Authorization', `Basic ${credentials}`),
      });
    }

    return next.handle(req);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/interceptors/auth.interceptor.ts